<template>
  <div id="app">
    <NavBar v-if="!isLandingPage" />
    <main :class="{ 'main-content': !isLandingPage }">
      <router-view></router-view>
    </main>
    <GlobalToast />
    <UpgradePlanModal :isOpen="showUpgradeModal" @close="closeUpgradeModal" />
    <PaymentResultHandler />
    <SkipOnboardingModal />
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import GlobalToast from './components/GlobalToast.vue'
import UpgradePlanModal from './components/UpgradePlanModal.vue'
import PaymentResultHandler from './components/PaymentResultHandler.vue'
import SkipOnboardingModal from './components/SkipOnboardingModal.vue'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'App',
  components: {
    NavBar,
    GlobalToast,
    UpgradePlanModal,
    PaymentResultHandler,
    SkipOnboardingModal
  },
  computed: {
    ...mapState('ui', ['showUpgradeModal']),
    isLandingPage() {
      return this.$route.name === 'Landing';
    }
  },
  methods: {
    ...mapActions('ui', ['closeUpgradeModal'])
  }
}
</script>

<style>
#app {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.main-content {
  margin-top: 80px; /* Add space for fixed navbar */
  padding: 2rem;
}

.navbar {
  background-color: rgb(var(--color-primary-600));
  color: white;
}

.navbar a {
  color: white;
}

/* If you have hover states, you might want to adjust those too */
.navbar a:hover {
  opacity: 0.9;
}
</style>
